import PropTypes from 'prop-types';
import imageExtensions from 'image-extensions';

import { getFileExtension } from '~/utils/fileExtension';
import ImageIcon from '~/assets/file-type-icons/image.svg';
import DocIcon from '~/assets/file-type-icons/doc.svg';
import XlsIcon from '~/assets/file-type-icons/xls.svg';
import PdfIcon from '~/assets/file-type-icons/pdf.svg';
import OtherIcon from '~/assets/file-type-icons/other.svg';
import ArchiveIcon from '~/assets/file-type-icons/archive.svg';

const fileExtensions = {
  image: imageExtensions,
  doc: ['doc', 'docx'],
  xls: ['xls', 'xlsx'],
  pdf: ['pdf'],
  archive: ['zip', 'rar', '7z', 'tar'],
};

const styles = {
  fileTypeWrapper: { display: 'inline-block', verticalAlign: 'top' },
};

const FileTypeIcon = ({ fileName, size, className }) => {
  const extension = getFileExtension(fileName);

  let fileTypeIcon;

  if (fileExtensions.image.includes(extension)) {
    fileTypeIcon = ImageIcon;
  } else if (fileExtensions.doc.includes(extension)) {
    fileTypeIcon = DocIcon;
  } else if (fileExtensions.xls.includes(extension)) {
    fileTypeIcon = XlsIcon;
  } else if (fileExtensions.pdf.includes(extension)) {
    fileTypeIcon = PdfIcon;
  } else if (fileExtensions.archive.includes(extension)) {
    fileTypeIcon = ArchiveIcon;
  } else {
    fileTypeIcon = OtherIcon;
  }

  return (
    <div style={styles.fileTypeWrapper} className={className}>
      <img
        src={fileTypeIcon}
        alt="File icon"
        style={{
          display: 'block',
          height: size,
          width: size,
        }}
      />
    </div>
  );
};

FileTypeIcon.propTypes = {
  fileName: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

FileTypeIcon.defaultProps = {
  size: 50,
  className: undefined,
};

export default FileTypeIcon;
